<!--
- 政策列表组件
- anthor: wang.y
- greatTime: 2019-08-12
-->
<template>
    <li>
        <div class="top">
          <div class="index">{{index + 1}}</div>
          <div class="title"><a v-html="filter.keyWordHighLight(dataLi.name, keyword)" @click="goEntityDetail(dataLi.uid)"></a></div>
        </div>
        <div class="time">
          <span>发布时间：{{dataLi.publish_time | time_moment}}</span>
          <div class="collect_share">
              <i class="iconfont s active" title="取消收藏" v-if="dataLi.is_collect > 0" @click="cancelCollect('3', dataLi.id, delCollectCb)">&#xe66f;</i>
              <i class="iconfont s" title="收藏" v-else  @click="addCollect('3', dataLi.id, addCollectCb)">&#xe66f;</i>
              <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(dataLi.uid)" @on-popper-hide="haddleShareHide">
                  <i class="iconfont w">&#xe641;</i>
                  <div slot="content" class="share_cnt clear">
                    <div class="share_img"></div>
                    <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                  </div>
              </Poptip>
          </div>
        </div>
    </li>
</template>

<script>
import filter from 'js/filter'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [ collect_mixin ],
  inject: ['login'],
  props: ['dataLi', 'index', 'keyword'],
  data() {
    return {
      filter: filter
    }
  },
  methods: {
    addCollectCb() {
      this.dataLi.is_collect = 1
    },
    delCollectCb() {
      this.dataLi.is_collect = 0
    },
    haddleShare(uid) {
      let share_link
      if(process.env.NODE_ENV == 'development') {
        share_link = 'http://192.168.1.104:8081/PolicyDetail/' + uid
      } else {
        share_link = this.$store.state.index_path+'/PolicyDetail/' + uid
      }
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    /**
    * 前往实体详情
    */
    goEntityDetail(uid) {
      if (this.$store.state.user_key) {
        // this.$router.push({ name: 'PolicyDetail', params:{ uid: uid} })
        const { href } = this.$router.resolve({
          name: "PolicyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else {
        this.login()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
li
  padding: 20px 0
  border-bottom: 1px dashed
  commonBorderColor(#40444F, #E9E9E9)
  .top
    display: flex
  >>> .high-light
    color: rgba(250, 122, 80, 1)
    font-style: normal
  .index
    flex: 0 0 30px
    font-size: 16px
    commonColor(#E9E9EB, #666666)
    display: flex
    line-height: 24px
  .title
    flex: auto
    font-size: 16px
    line-height: 24px
    a
      display: block
      commonColor(#E9E9EB, #333333)
      &:hover
        color: rgba(250, 122, 80, 1)
  .time
    flex: 0 0 200px
    font-size: 12px
    commonColor(#BCBDC1, #999999)
    display: flex
    align-items: center
    justify-content: flex-end
    width: 100%
    padding-left: 30px
    margin-top: 7px
    span
      flex: auto
    .collect_share
      flex: 0 0 44px
</style>
